import isEmpty from "ramda/es/isEmpty";
import isNil from "ramda/es/isNil";
import { baseValidationTypes } from '../../constants';
import createValidationFn from '../../createValidationFn';
/**
 * Validate required field
 *
 * @documented
 * @category Common
 * @import import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common'
 * @param {String} [messageKey=requiredField]
 * @returns {String} errMessage
 *
 */ export const isRequired = createValidationFn(({ messageKey = 'requiredField' })=>({ fieldValue })=>(isNil(fieldValue) || isEmpty(fieldValue)) && messageKey, {
    type: baseValidationTypes.REQUIRED
});
/**
 * Validate required field when field is visible and not disabled
 *
 * @documented
 * @category Common
 * @import import { isRequiredAccessible } from '@gef-ui/form-core/validations/validationFunctions/common'
 * @param {String} [messageKey=requiredField]
 * @returns {String} errMessage
 *
 */ export const isRequiredAccessible = createValidationFn(({ messageKey = 'requiredField' })=>({ fieldValue, fieldRecord, formFieldState })=>{
        const fieldState = formFieldState[fieldRecord];
        if (!fieldState || fieldState.disabled) {
            return false;
        }
        return (isNil(fieldValue) || isEmpty(fieldValue)) && messageKey;
    }, {
    type: baseValidationTypes.REQUIRED
});
/**
 * handy debug logger for validations
 *
 * @documented
 * @category Common
 * @import import { debugValidationLogger } from '@gef-ui/form-core/validations/validationFunctions/common'
 * @returns {undefined}
 *
 */ export const debugValidationLogger = createValidationFn(()=>({ fieldRecord, ...args })=>{
        console.log(`validating field record: ${fieldRecord} with args:`, args);
    }, {
    type: baseValidationTypes.REQUIRED
});
